module.exports = __webpack_public_path__ + "static/wellness_sp-9ea4517d6d1ece5b0c6fc1c366d989f2.png";